import { useMemo } from 'react';

import { FIELD_REPORT_STATUS_COLORS } from '../FormStatus';
import { FORM_STATUSES, FEATURE_FLAGS } from '../helpers/constants';
import { useTranslation } from '../i18n';
import { usePlangridFeatureFlag } from '../PlangridLaunchDarklyProvider';

const useFormStatusOptions = () => {
  const { value: isStatusExpansionEnabled } = usePlangridFeatureFlag(
    FEATURE_FLAGS.STATUS_EXPANSION,
    false,
  );
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        label: t('ARCHIVED'),
        value: FORM_STATUSES.ARCHIVED,
        color: FIELD_REPORT_STATUS_COLORS[FORM_STATUSES.ARCHIVED],
      },
      {
        label: isStatusExpansionEnabled ? t('IN_PROGRESS') : t('DRAFT'),
        value: FORM_STATUSES.DRAFT,
        color: FIELD_REPORT_STATUS_COLORS[FORM_STATUSES.DRAFT],
      },
      {
        label: t('IN_REVIEW'),
        value: FORM_STATUSES.IN_REVIEW,
        color: FIELD_REPORT_STATUS_COLORS[FORM_STATUSES.IN_REVIEW],
      },
      {
        label: isStatusExpansionEnabled ? t('CLOSED') : t('SUBMITTED'),
        value: FORM_STATUSES.SUBMITTED,
        color: FIELD_REPORT_STATUS_COLORS[FORM_STATUSES.SUBMITTED],
      },
    ],
    [isStatusExpansionEnabled, t],
  );
};

export default useFormStatusOptions;
